import { Link } from "react-router-dom";
import useCategories from '../../../hooks/use-categories';
import useLocalization from '../../../hooks/use-localization';
import Separator from '../../shared/Separator';

export default function Categories() {

    const categories = useCategories();
    const localization = useLocalization();

    const categoriesArray = [];
    for (let prop in categories) {

        var categoryObj = {
            key: prop,
            name: categories[prop],
        };

        categoriesArray.push(categoryObj);
    }

    categoriesArray.sort((a, b) => {
        if (a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
        if (a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }

        return 0;
    });

    const renderedCategories = categoriesArray.map(c => {
        const path = `/news/${c.key}`;
        return <p key={c.key}>
            <Link to={path}>{c.name}</Link>
        </p>
    });

    return (
        <div className="post-widget color-purple">
            <h4 className="text-center">{localization.newsManagement.categoriesLabel}</h4>
            <div>
                <Separator className="color-blue"></Separator>
            </div>
            <div>{renderedCategories}</div>
        </div>
    );
}